import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { toast } from "sonner";
import { fmt, demoStats } from "../data/store";
import { useCart } from "../context/CartContext";

export const ProductCard = ({ product }) => {
  const { add } = useCart();
  const stats = demoStats(product);
  const handleAdd = (e) => {
    e.preventDefault();
    add(product, 1);
    toast.success("Pievienots grozam", { description: product.name });
  };

  return (
    <Link to={`/prece/${product.id}`} data-testid={`product-card-${product.id}`}
      className="group relative flex flex-col bg-white border border-[#E2E2E2] rounded-md overflow-hidden transition-all duration-200 hover:border-[#111111] hover:shadow-md">
      <div className="absolute top-2 left-2 z-10 flex flex-col gap-1">
        {product.oldPrice && <span className="bg-[#D0121A] text-white text-[11px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-sm">Akcija</span>}
        {product.isNew && <span className="bg-[#111111] text-white text-[11px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-sm">Jaunums</span>}
      </div>
      <div className="aspect-square bg-[#F5F5F5] overflow-hidden">
        <img src={product.image} alt={product.name} loading="lazy"
          className="w-full h-full object-cover mix-blend-multiply transition-transform duration-300 group-hover:scale-105" />
      </div>
      <div className="flex flex-col flex-1 p-4 gap-1">
        <span className="text-xs text-[#6B6B6B] font-medium">{product.brand}</span>
        <h3 className="text-sm font-semibold text-[#111111] leading-snug line-clamp-2 min-h-[2.5rem]">{product.name}</h3>
        <div className="flex items-center gap-1.5 text-xs">
          <span className={`w-2 h-2 rounded-full ${product.stock ? "bg-[#1E9E45]" : "bg-[#E5A000]"}`} />
          <span className="text-[#6B6B6B]">{product.stock ? "Noliktavā" : "Pēc pasūtījuma"}</span>
        </div>
        {stats.low ? (
          <span className="text-[11px] font-bold text-[#D0121A]" data-testid={`urgency-${product.id}`}>Palicis maz: {stats.stockLevel} gab.</span>
        ) : stats.top ? (
          <span className="text-[11px] font-bold text-[#E5A000]" data-testid={`urgency-${product.id}`}>★ Top izvēle šajā kategorijā</span>
        ) : stats.soldWeek > 50 ? (
          <span className="text-[11px] text-[#6B6B6B]" data-testid={`urgency-${product.id}`}>Pārdoti {stats.soldWeek} gab. šonedēļ</span>
        ) : null}
        {product.packQty > 1 && <span className="text-xs text-[#6B6B6B]">Iepakojumā: {product.packQty} gab.</span>}
        <div className="mt-auto pt-2 flex items-end justify-between gap-2">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="text-lg font-bold text-[#111111]">{fmt(product.price)}</span>
              {product.oldPrice && <span className="text-sm line-through text-[#6B6B6B]">{fmt(product.oldPrice)}</span>}
            </div>
            <span className="text-[11px] text-[#6B6B6B]">ar PVN</span>
          </div>
          <button onClick={handleAdd} data-testid={`add-to-cart-${product.id}`} aria-label="Pievienot grozam"
            className="shrink-0 bg-[#D0121A] hover:bg-[#A80D14] text-white rounded-md p-2.5 transition-all duration-200 md:opacity-0 md:group-hover:opacity-100">
            <ShoppingCart size={18} />
          </button>
        </div>
      </div>
    </Link>
  );
};
